import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class ReturnDispatch extends Component {
	render(){
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Return Dispatch Jobs
					</div>
					<div>
						<DownloadFile title="Return Dispatch Jobs Header" url="ingest/returns-dispatch/imrs/trigger/template"/>
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="ingest/returns-dispatch/imrs/trigger "/>
					</div>
				</div>
				<div className="white-box margin-top-thirty">
					<div className="page-header-title">
						Returns Crate Dispatch Jobs
					</div>
					<div>
						<DownloadFile title="Returns Crate Dispatch Jobs Header" url="ingest/returns-dispatch/grouped/jobs/header"/>
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="ingest/returns-dispatch/grouped/jobs/trigger"/>
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/SellerReturns/Components/ReturnDispatch.js